module.exports = __webpack_public_path__ + "static/illoom-logo-50f08f7cf60e8d4365071d28e3c336eb.svg";